/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Intro_Title_2_PreInputs */

const tr_landing_intro_title_2_pre = /** @type {(inputs: Landing_Intro_Title_2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel'de fiyatlar ayda sadece`)
};

const en_landing_intro_title_2_pre = /** @type {(inputs: Landing_Intro_Title_2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On ShopPanel, prices start at just`)
};

const de_landing_intro_title_2_pre = /** @type {(inputs: Landing_Intro_Title_2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei ShopPanel beginnen die Preise bei nur`)
};

const ru_landing_intro_title_2_pre = /** @type {(inputs: Landing_Intro_Title_2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В ShopPanel цены начинаются всего от`)
};

/**
* | output |
* | --- |
* | "On ShopPanel, prices start at just" |
*
* @param {Landing_Intro_Title_2_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_intro_title_2_pre = /** @type {((inputs?: Landing_Intro_Title_2_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Intro_Title_2_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_intro_title_2_pre(inputs)
	if (locale === "de") return de_landing_intro_title_2_pre(inputs)
	if (locale === "ru") return ru_landing_intro_title_2_pre(inputs)
	return tr_landing_intro_title_2_pre(inputs)
});